// src/components/Header.tsx
import { Layout, Button, Space } from 'antd';
import Logo from '../assets/logo.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitch from './LanguageSwitch';

const { Header: AntHeader } = Layout;

const Header = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <AntHeader className="site-header">
      <div className="header-container">
        <div className="logo" onClick={() => navigate('/')}>
          <img src={Logo} alt="Ailicorn" className="logo-img" />
          <span className="logo-text">Ailicorn</span>
        </div>

        <Space size="large" className="nav-menu">
          <Button type="text" className="nav-button" onClick={() => navigate('/team')}>
            {t('header.about')}
          </Button>
          <Button type="text" className="nav-button" onClick={() => navigate('/contact')}>
            {t('header.contact')}
          </Button>
          <LanguageSwitch />
        </Space>
      </div>
    </AntHeader>
  );
};

export default Header;
